import { GTMEvent } from '../GTM'

type ApplyCouponPayload = {
    coupon: string
    success: boolean
    source: 'manual'
}

export const pushApplyCoupon = (data: Record<string, unknown>): GTMEvent => {
    const {
        coupon = '',
        success = false,
        source = 'manual'
    } = data as ApplyCouponPayload

    return {
        event: 'apply_coupon',
        data: {
            coupon,
            success,
            source
        }
    }
}
